import { render, staticRenderFns } from "./p-export-prompt.vue?vue&type=template&id=4dfe2471&"
import script from "./p-export-prompt.vue?vue&type=script&lang=js&"
export * from "./p-export-prompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports